export default [
    {
        name: 'Lang Code',
        value: "'%LangCode%'",
        js: 'window._globalTracking.LangCode'
    },
    {
        name: 'Lang Code JS',
        value: "'%JS_LangCode%'",
        js: 'window._globalTracking.LangCode'
    },
    {
        name: 'Lang Code',
        value: "'%LangCode%'",
        js: 'window._globalTracking.LangCode'
    },
    {
        name: 'Daily Rate',
        value: "'%JS_DailyRateWithTax%'",
        js: 'window._globalTracking.ItineraryDailyRate'
    },
    {
        name: 'Daily Rate with tax',
        value: "'%JS_DailyRate%'",
        js: 'window._globalTracking.ItineraryDailyRateWithTax'
    },
    {
        name: 'Taxes',
        value: "'%JS_Taxes%'",
        js: 'window._globalTracking.Taxes'
    },
    {
        name: 'Total Cost',
        value: "'%JS_TotalCost%'",
        js: 'window._globalTracking.TotalCost'
    },
    {
        name: 'Total Cost with Tax',
        value: "'%JS_TotalCostWithTax%'",
        js: 'window._globalTracking.TotalCostWithTax'
    },
    {
        name: 'Chain ID',
        value: "'%JS_CHAIN_ID%'",
        js: 'window._globalTracking.CHAIN_ID'
    },
    {
        name: 'Chain Name',
        value: "'%JS_ChainNm%'",
        js: 'window._globalTracking.ChainNm'
    },
    {
        name: 'Hotel Name',
        value: "'%JS_HName%'",
        js: 'window._globalTracking.HName'
    },
    {
        name: 'Hotel ID',
        value: "'%JS_HOTEL_ID%'",
        js: 'window._globalTracking.HOTEL_ID'
    },
    {
        name: 'Rate ID',
        value: "'%JS_rateId%'",
        js:
            'window._globalTracking.AddedRoomList && window._globalTracking.AddedRoomList[0] && window._globalTracking.AddedRoomList[0].RateCode'
    },
    {
        name: 'Rate Code',
        value: "'%JS_RateTypCd%'",
        js:
            'window._globalTracking.AddedRoomList && window._globalTracking.AddedRoomList[0] && window._globalTracking.AddedRoomList[0].RateCode'
    },
    {
        name: 'Rate Long Description',
        value: "'%JS_RateLongDesc%'",
        js:
            'window._globalTracking.AddedRoomList && window._globalTracking.AddedRoomList[0] && window._globalTracking.AddedRoomList[0].RateLongDesc'
    },
    {
        name: 'Rate Name',
        value: "'%JS_RateName%'",
        js:
            'window._globalTracking.AddedRoomList && window._globalTracking.AddedRoomList[0] && window._globalTracking.AddedRoomList[0].RateName'
    },
    {
        name: 'Rate Short Description',
        value: "'%JS_RateShortDesc%'",
        js:
            'window._globalTracking.AddedRoomList && window._globalTracking.AddedRoomList[0] && window._globalTracking.AddedRoomList[0].RateShortDesc'
    },
    {
        name: 'Rate Type Code',
        value: "'%JS_RateTypCd%'",
        js:
            'window._globalTracking.AddedRoomList && window._globalTracking.AddedRoomList[0] && window._globalTracking.AddedRoomList[0].RateCode'
    },
    {
        name: 'Room ID',
        value: "'%JS_roomId%'",
        js:
            'window._globalTracking.AddedRoomList && window._globalTracking.AddedRoomList[0] && window._globalTracking.AddedRoomList[0].RoomCode'
    },
    {
        name: 'Room Code',
        value: "'%JS_RmTypCd%'",
        js:
            'window._globalTracking.AddedRoomList && window._globalTracking.AddedRoomList[0] && window._globalTracking.AddedRoomList[0].RoomCode'
    },
    {
        name: 'Room Long Description',
        value: "'%JS_RoomLongDesc%'",
        js:
            'window._globalTracking.AddedRoomList && window._globalTracking.AddedRoomList[0] && window._globalTracking.AddedRoomList[0].RoomLongDesc'
    },
    {
        name: 'Room Name',
        value: "'%JS_RoomName%'",
        js:
            'window._globalTracking.AddedRoomList && window._globalTracking.AddedRoomList[0] && window._globalTracking.AddedRoomList[0].RoomName'
    },
    {
        name: 'Room Short Description',
        value: "'%JS_RoomShortDesc%'",
        js:
            'window._globalTracking.AddedRoomList && window._globalTracking.AddedRoomList[0] && window._globalTracking.AddedRoomList[0].RoomShortDesc'
    },
    {
        name: 'Adult Quantity',
        value: "'%JS_AdultQty%'",
        js: 'window._globalTracking.AdultQty'
    },
    {
        name: 'Arrival Date',
        value: "'%JS_ArrivalDt%'",
        js: 'window._globalTracking.ArrivalDt'
    },
    {
        name: 'Arrival Date (YYYYMMDD)',
        value: "'%JS_ArrivalDtYYYYMMDD%'",
        js: 'window._globalTracking.ArrivalDtYYYYMMDD'
    },
    {
        name: 'Booking Date',
        value: "'%JS_BookDt%'",
        js: 'window._globalTracking.Cart && window._globalTracking.Cart[0] && window._globalTracking.Cart[0].BookDt'
    },
    {
        name: 'Booking Pace',
        value: "'%JS_BookingPace%'",
        js:
            'window._globalTracking.Cart && window._globalTracking.Cart[0] && window._globalTracking.Cart[0].DaysToCheckIn'
    },
    {
        name: 'Cancellation Number',
        value: "'%JS_CancelConfirmNo%'",
        js:
            'window._globalTracking.Cart && window._globalTracking.Cart[0] && window._globalTracking.Cart[0].CancelConfirmNo'
    },
    {
        name: 'Children Quantity',
        value: "'%JS_ChildQty%'",
        js: 'window._globalTracking.ChildQty'
    },
    {
        name: 'Confirmation Number',
        value: "'%JS_ConfirmNo%'",
        js: 'window._globalTracking.Cart && window._globalTracking.Cart[0] && window._globalTracking.Cart[0].ConfirmNo'
    },
    {
        name: 'Currency Code',
        value: "'%JS_CurrCode%'",
        js: 'window._globalTracking.CurrCode'
    },
    {
        name: 'Currency Prefix',
        value: "'%JS_CurrPrefix%'",
        js: 'window._globalTracking.CurrCode'
    },
    {
        name: 'Days to Check-in',
        value: "'%JS_DaysToCheckIn%'",
        js:
            'window._globalTracking.Cart && window._globalTracking.Cart[0] && window._globalTracking.Cart[0].DaysToCheckIn'
    },
    {
        name: 'Departure Date',
        value: "'%JS_DepartDt%'",
        js: 'window._globalTracking.DepartDt'
    },
    {
        name: 'Group Code',
        value: "'%JS_GroupCode%'",
        js: 'window._globalTracking.GroupCode'
    },
    {
        name: 'Group Name',
        value: "'%JS_GroupName%'",
        js: 'window._globalTracking.GroupName'
    },
    {
        name: 'Guest Quantity',
        value: "'%JS_GuestQty%'",
        js: 'window._globalTracking.GuestQty'
    },
    {
        name: 'Nights Quantity',
        value: "'%JS_NightsQty%'",
        js: 'window._globalTracking.NightsQty'
    },
    {
        name: 'Promo Code',
        value: "'%JS_PromoCode%'",
        js: 'window._globalTracking.PromoCode'
    },
    {
        name: 'Promo Name',
        value: "'%JS_PromoName%'",
        js: 'window._globalTracking.PromoName'
    },
    {
        name: 'Reservation Status',
        value: "'%JS_ResvStatus%'",
        js: 'window._globalTracking.ResvStatus'
    },
    {
        name: 'Reservation Type',
        value: "'%JS_ResvType%'",
        js: 'window._globalTracking.ResvType'
    },
    {
        name: 'Room Quantity',
        value: "'%JS_RmQty%'",
        js: 'window._globalTracking.RmQty'
    },
    {
        name: 'Room Nights Quantity',
        value: "'%JS_RoomNightsQty%'",
        js: 'window._globalTracking.RoomNightsQty'
    },
    {
        name: 'Template Code',
        value: "'%TemplateCode%'",
        js: 'window._globalTracking.ThemeCode'
    },
    {
        name: 'Template ID',
        value: "'%TemplateID%'",
        js: 'window._globalTracking.ThemeCode'
    }
];



// WEBPACK FOOTER //
// ./src/components/widgets/Editor/trackingVariables.js